import { defineStore } from 'pinia';

export const useConnectDialogStore = defineStore('connectDialog', {
  state: () => ({
    dialog: false,
  }),
});
